import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getVehicleScoreDay } from '../../services/VehiclesService';
import { VehicleScoreDay } from '../../types/Vehicles';
import { FeaturesManagement } from '../../../featuresControl';

function useGetVehicleScoreDay(
  id: string,
  fleetId: string,
  date: string,
): UseQueryResult<VehicleScoreDay> {
  return useQuery(
    ['vehicle-score-day', id, fleetId, date],
    async (): Promise<VehicleScoreDay> => getVehicleScoreDay(id, fleetId, date),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      enabled: !!id && !!date,
    },
  );
}

export default useGetVehicleScoreDay;
